<template>

<core-panel>

	<template v-slot:head>

		<h1>Recent Plays</h1>

		<p>All <b>{{ plays.length }}</b> play sessions of this game.</p>

	</template>

	<template v-slot:body>

		<app-users :item="item" v-for="(item, index) in plays" :key="index">

			<div class="recent-date"><core-date :date="item.date" size="small" v-if="item.date" /></div>

		</app-users>

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'recent',
			plays: []
		}

	},

	methods: {

		response: function(json) {

			this.plays = json.recent.list

		}

	}

}

</script>

<style scoped>

.recent-date {
	flex-shrink: 0;
	display: flex;
	align-items: center;
}

</style>
